import { ColumnsType } from "antd/es/table";
import { TFunctionType } from "src/static/constants";

const formatNum = (val: number | null | undefined) => {
  if (val === null || val === undefined) return "";
  const abs = Math.abs(Math.round(val));
  const formatted = abs.toLocaleString("en-US");
  if (val < 0) return `(${formatted})`;
  return formatted;
};

export interface ISvodFlatRow {
  key: string;
  rowIndex?: number;
  monthLabel: string;
  category: string;
  installed_kw: number | null;
  materials: number | null;
  installation: number | null;
  logistics: number | null;
  other_production: number | null;
  office_expenses: number | null;
  total_cost: number | null;
  volume: number | null;
  profit_with_office_uzs: number | null;
  profit_with_office_usd: number | null;
  profit_without_office_uzs: number | null;
  profit_without_office_usd: number | null;
  isMonthTotal?: boolean;
  isYearTotal?: boolean;
}

const mergedCell = (record: ISvodFlatRow) => {
  if (record.isMonthTotal) return { rowSpan: 3 };
  return { rowSpan: 0 };
};

export const svodObjectColumns = (t: TFunctionType): ColumnsType<ISvodFlatRow> => [
  {
    title: "№",
    dataIndex: "rowIndex",
    key: "rowIndex",
    width: 40,
    fixed: "left",
    onCell: (record) => mergedCell(record),
    render: (val) => val ?? "",
  },
  {
    title: t("sidebar.analyses.monthName"),
    dataIndex: "category",
    key: "category",
    width: 110,
    fixed: "left",
  },
  {
    title: t("sidebar.analyses.installedPower"),
    dataIndex: "installed_kw",
    key: "installed_kw",
    width: 100,
    render: (val) => formatNum(val),
  },
  {
    title: t("sidebar.analyses.costGroupTitle"),
    children: [
      {
        title: t("sidebar.analyses.goods"),
        dataIndex: "materials",
        key: "materials",
        width: 150,
        render: (val: number | null) => formatNum(val),
      },
      {
        title: t("sidebar.analyses.installation"),
        dataIndex: "installation",
        key: "installation",
        width: 130,
        render: (val: number | null) => formatNum(val),
      },
      {
        title: t("sidebar.analyses.logistics"),
        dataIndex: "logistics",
        key: "logistics",
        width: 130,
        render: (val: number | null) => formatNum(val),
      },
      {
        title: t("sidebar.analyses.otherProduction"),
        dataIndex: "other_production",
        key: "other_production",
        width: 140,
        render: (val: number | null) => formatNum(val),
      },
      {
        title: t("sidebar.analyses.officeExpenses"),
        dataIndex: "office_expenses",
        key: "office_expenses",
        width: 140,
        render: (val: number | null) => formatNum(val),
      },
    ],
  },
  {
    title: t("sidebar.analyses.totalCost"),
    dataIndex: "total_cost",
    key: "total_cost",
    width: 155,
    render: (val) => <strong>{formatNum(val)}</strong>,
  },
  {
    title: t("sidebar.analyses.volume"),
    dataIndex: "volume",
    key: "volume",
    width: 155,
    render: (val) => formatNum(val),
  },
  {
    title: t("sidebar.analyses.profitOrLoss"),
    children: [
      {
        title: t("sidebar.analyses.profitWithOffice"),
        children: [
          {
            title: t("sidebar.analyses.inUzs"),
            dataIndex: "profit_with_office_uzs",
            key: "profit_with_office_uzs",
            width: 155,
            render: (val: number | null) => formatNum(val),
          },
          {
            title: t("sidebar.analyses.inUsd"),
            dataIndex: "profit_with_office_usd",
            key: "profit_with_office_usd",
            width: 100,
            render: (val: number | null) => formatNum(val),
          },
        ],
      },
      {
        title: t("sidebar.analyses.profitWithoutOffice"),
        children: [
          {
            title: t("sidebar.analyses.inUzs"),
            dataIndex: "profit_without_office_uzs",
            key: "profit_without_office_uzs",
            width: 155,
            render: (val: number | null) => formatNum(val),
          },
          {
            title: t("sidebar.analyses.inUsd"),
            dataIndex: "profit_without_office_usd",
            key: "profit_without_office_usd",
            width: 100,
            render: (val: number | null) => formatNum(val),
          },
        ],
      },
    ],
  },
];
